import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { useContext } from 'react';
import { RootState } from '../../../../../Redux/Store';
import { AppContext } from '../../../../../Context/AppContext';
import { useAppSelector } from '../../../../../Hooks/Hooks';
import { timezone, utc } from '../../../../../Utils/DateUtils';
import { getMemberDetails } from '../../../../../Utils/Search';
import BookNowTable from '../../../BookNowTable/BookNowTable';
import './LoadRateContainer.scss';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

type TLoadRateContainerProps = {
  rate: any;
  tableTitle: string;
  isMemberDetailVisible?: boolean;
  totalCostAmount?: string;
  isMyLoads?: boolean;
};
const tableColumnTitle = ['Charge Description', 'Rate/ Qualifier', 'Qty', 'Total'];
const LoadRateContainer = (props: TLoadRateContainerProps) => {
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { isMobile } = useContext(AppContext);
  const memberDetails = getMemberDetails(memberData, isMobile);

  return (
    <div className="LoadRateContainer">
      {props.isMemberDetailVisible && (
        <div className="MemberDetails">
          {memberDetails.map((item) => (
            <>
              {item.label !== '' && item.value !== '' && (
                <div className="Detail_Item">
                  <div className="MemberDetails_Heading">{item.label} :</div>
                  <div className="MemberDetails_Details">{item.value}</div>
                </div>
              )}
            </>
          ))}
        </div>
      )}
      <BookNowTable
        data={props.rate}
        tableTitle={props.tableTitle}
        tableColumnTitle={tableColumnTitle}
        totalCostAmount={props.totalCostAmount}
        isMyLoads={props.isMyLoads}
      />
    </div>
  );
};

export default LoadRateContainer;
